/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./InstitutionsGrid.vue?vue&type=template&id=791d21c8"
import script from "./InstitutionsGrid.vue?vue&type=script&lang=js"
export * from "./InstitutionsGrid.vue?vue&type=script&lang=js"
import style0 from "./InstitutionsGrid.vue?vue&type=style&index=0&id=791d21c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports